const ITEMS = [
    "Zero Brokerage",
    "Direct Developer Connection",
    "New Projects Only",
    "Residential & Commercial",
    "Pan-India Discovery",
    "Curated, Never Crowded",
];

export default function Marquee() {
    return (
        <div
            data-testid="editorial-marquee"
            className="overflow-hidden border-y border-black/5 py-5"
            aria-hidden="true"
        >
            <div className="marquee-track">
                {[...ITEMS, ...ITEMS].map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className="mx-8 font-mono text-[11px] uppercase tracking-[0.35em] text-dim">
                            {item}
                        </span>
                        <span className="text-[10px] text-gold">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
